@if (theme) {
  <div #entryListings class="{{ theme?.root }}" [style]="theme?.bgImage">
    <div class="container {{ theme?.container }}">
      @if (entryListingsTitle) {
        <div
          class="p-v-spacing pb-4 pt-v-spacing wysiwyg mb-8"
          [innerHTML]="entryListingsTitle"
        ></div>
      }
      <div class="flex flex-col lg:flex-row lg:flex-row-reverse lg:mb-v-spacing" [class.lg:mr-v-spacing]="theme?.container.length === 0">
        <div class="flex flex-col mx-0 bg-gray-200 p-v-spacing rounded-md mb-v-spacing lg:items-start lg:bg-transparent lg:pt-0 lg:w-sidebar lg:min-w-sidebar"
          >
          @if (stateList.length > 0) {
            <div class="px-0 flex w-full lg:bg-gray-200 lg:pt-v-spacing lg:px-v-spacing pb-2 rounded-t-md lg:ml-v-spacing">
              <p class="mb-2 md:mb-0 font-bold filter-title">{{ filterStateTitle }}</p>
            </div>
          }
          @if (stateList.length > 0) {
            <div
              class="flex flex-col px-0 align-items-center w-full lg:flex-row lg:bg-gray-200 sm:px-v-spacing lg:pb-v-spacing rounded-b-md lg:ml-v-spacing"
              >
              <select
                class="select-filter dropdown-native mr-v-spacing lg:mr-0 text-base font-light appearance-none w-full whitespace-nowrap text-left cursor-pointer select-none rounded-md leading-6 h-full"
                (change)="onStateFilterChange($event.target.selectedOptions[0].dataset['slug'], $event.target.selectedOptions[0].dataset['id'])"
                [(ngModel)]="selectedStateFilter"
                aria-label="Filter articles by state"
                >
                <option value="">{{ filterStateDefaultLabel }}</option>
                @for (state of stateList; track state) {
                  <option [value]="state.slug" [attr.data-slug]="state.slug" [attr.data-id]="state.id">
                    {{ state.title }}
                  </option>
                }
              </select>
            </div>
          }
          @if (entryListingContent) {
            <div
              class="py-v-spacing sm:px-v-spacing lg:pt-0 wysiwyg hidden lg:block"
              [class.mt-v-spacing]="!entryListingsTitle"
              [innerHTML]="entryListingContent"
            ></div>
          }
          @if (categoryList.length > 0) {
            <div class="px-0 flex w-full lg:bg-gray-200 lg:pt-v-spacing lg:px-v-spacing pb-2 rounded-t-md lg:ml-v-spacing" [class.mt-8]="stateList.length > 0">
              <p class="mb-2 md:mb-0 font-bold filter-title">{{ filterCategoryTitle }}</p>
            </div>
          }
          @if (categoryList.length > 0) {
            <div
              class="flex flex-col px-0 align-items-center w-full lg:flex-row lg:bg-gray-200 sm:px-v-spacing lg:pb-v-spacing rounded-b-md lg:ml-v-spacing"
              >
              <select
                class="select-filter dropdown-native mr-v-spacing lg:mr-0 text-base font-light appearance-none w-full whitespace-nowrap text-left cursor-pointer select-none rounded-md leading-6 h-full"
                (change)="onCategoryFilterChange($event.target.selectedOptions[0].dataset['slug'], $event.target.selectedOptions[0].dataset['id'])"
                [(ngModel)]="selectedCategoryId"
                aria-label="Filter articles by category"
                >
                <option value="">All Categories</option>
                @for (category of categoryList; track category) {
                  <option [value]="category.id" [attr.data-slug]="category.slug" [attr.data-id]="category.id">
                    {{ category.title }}
                  </option>
                }
              </select>
            </div>
          }
        </div>
        <div class="w-full grid grid-cols-1 sm:grid-cols-2 sm:gap-x-6 lg:w-auto" [ngClass]="{'sm:px-v-spacing': theme?.container.length === 0}">
          @if (pages[activeIndex] && pages[activeIndex].length > 0) {
            @for (card of pages[activeIndex]; track card) {
              <entry-listing-article-card
                [data]="card"
                class="card my-v-spacing sm:mt-0"
                >
              </entry-listing-article-card>
            }
          }
        </div>
      </div>
      @if (pages.length > 1) {
        <nav role="pagination" class="w-full py-v-spacing px-0 mt-v-spacing text-center">
          <ul class="flex justify-center">
            <li class="page-item cursor-pointer" [ngClass]="{ hidden: activeIndex === 0 }">
              <a [href]="getPageUrl(activeIndex - 1)" [attr.aria-label]="'Go to page ' + activeIndex">
                <fa-icon
                  class="fa-1x page-link"
                  [icon]="faArrowLeft"
                  aria-hidden="true"
                ></fa-icon>
              </a>
            </li>
            <li
              class="page-item cursor-pointer"
              [ngClass]="{ hidden: pageWindowIndex === 0 }"
              >
              <a [href]="getPageUrl(0)" aria-label="Go to first page">
                <fa-icon class="fa-1x page-link" [icon]="faEllipsisH" aria-hidden="true"></fa-icon>
              </a>
            </li>
            @for (page of pages; track page; let i = $index) {
              <li
                class="page-item page-number"
          [ngClass]="{
            'paging-end': i === pageWindowIndex + 3,
            'pre-page': i < pageWindowIndex && pageWindowIndex !== 0
          }"
                >
                <a
                  class="button page-link cursor-pointer"
                  [ngClass]="{ active: i === activeIndex }"
                  [href]="getPageUrl(i)"
                  [attr.aria-label]="'Go to page ' + (i + 1)"
                  [attr.aria-current]="i === activeIndex ? 'page' : null"
                  >
                  {{ i + 1 }}
                </a>
              </li>
            }
            <li
              class="page-item cursor-pointer"
              [ngClass]="{ hidden: pageWindowIndex + 4 >= pages.length }"
              >
              <a [href]="getPageUrl(pages.length - 1)" aria-label="Go to last page">
                <fa-icon
                  class="fa-1x page-link"
                  [icon]="faEllipsisH"
                  aria-hidden="true"
                ></fa-icon>
              </a>
            </li>
            <li class="page-item cursor-pointer" [ngClass]="{ hidden: activeIndex === pages.length - 1 }">
              <a [href]="getPageUrl(activeIndex + 1)" [attr.aria-label]="'Go to page ' + (activeIndex + 2)">
                <fa-icon
                  class="fa-1x page-link"
                  [icon]="faArrowRight"
                  aria-hidden="true"
                ></fa-icon>
              </a>
            </li>
          </ul>
        </nav>
      }
      <hr class="md:hidden my-v-spacing" />
      @if (entryListingContent) {
        <div
          class="py-v-spacing lg:px-v-spacing wysiwyg block lg:hidden"
          [innerHTML]="entryListingContent"
        ></div>
      }
    </div>
  </div>
}
